// Author Pan Yu Rou
// Date 2024-12-10 18:05:40

import * as model from "@/model/sithMes/prd/SithMesPrdZpp2Model.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdZpp2(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
        callbackApi: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesPrdZpp2/complete-feedback',
        processDefinitionKey: "prd_zpp2",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
